'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sv_SE = require('../../date-picker/locale/sv_SE');

var _sv_SE2 = _interopRequireDefault(_sv_SE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _sv_SE2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/sv_SE.tsx
 ** module id = 739
 ** module chunks = 1
 **/